var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 66,
    viewBox: "0 0 128 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.108 2.3375H38.687V63.6628H126.108V2.3375Z",
    fill: "#E9BCC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.108 2.3375L82.3975 32.6085L38.687 2.3375",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6647 0.380257V8.86151H0V12.776H36.6647V31.043H6.263V34.9573H36.6647V42.1335H12.004V46.0478H36.6645V65.6195H128V0.380257H36.6647ZM124.086 61.7055H40.579V6.07376L82.3315 34.989L113.117 13.6968L110.89 10.4773L82.333 30.2288L44.8857 4.2945H124.086V61.7055Z",
    fill: "#1C1C24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.639 7.87462L116.871 11.0898L120.086 8.85749L117.854 5.64232L114.639 7.87462Z",
    fill: "#1C1C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91425 53.2243H0V57.1385H3.91425V53.2243Z",
    fill: "#1C1C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8809 53.2243H8.48145V57.1385H32.8809V53.2243Z",
    fill: "#1C1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91425 19.952H0V23.8662H3.91425V19.952Z",
    fill: "#1C1C24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8809 19.952H8.48145V23.8662H32.8809V19.952Z",
    fill: "#1C1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter1);
export default __webpack_public_path__ + "static/media/letter1.c983112c06f22657a2754cfd730475fe.svg";
export { ForwardRef as ReactComponent };